import BpkButton from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkCloseButton from '@skyscanner-internal/backpack-web/bpk-component-close-button';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkLargeChevronLeft from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/chevron-left';
import { BpkVessel } from '@skyscanner-internal/backpack-web/bpk-component-layout';

import STYLES from './NavigationButton.module.scss';

const BpkLargeChevronLeftIcon = withRtlSupport(BpkLargeChevronLeft);

export const NAVIGATION_BUTTON_TYPES = {
  BACK: 'back',
  CLOSE: 'close',
} as const;

type NavigationButtonType = (typeof NAVIGATION_BUTTON_TYPES)[keyof typeof NAVIGATION_BUTTON_TYPES];

type NavigationButtonProps = {
  ariaLabel?: string;
  handleClick: () => void;
  type: NavigationButtonType;
};

const NavigationButton = ({ ariaLabel, handleClick, type }: NavigationButtonProps) => {
  const isBack = type === NAVIGATION_BUTTON_TYPES.BACK;

  if (!isBack) {
    return (
      <BpkVessel className={STYLES['navigation-button--close']}>
        <BpkCloseButton
          className={STYLES['navigation-button__close-icon']}
          label={ariaLabel ?? ''}
          onClick={handleClick}
        />
      </BpkVessel>
    );
  }

  return (
    <div className={STYLES['navigation-button--back']}>
      <BpkButton
        className={STYLES['navigation-button__icon']}
        onClick={handleClick}
        aria-label={ariaLabel}
      >
        <BpkLargeChevronLeftIcon className={STYLES['navigation-button__icon']} />
      </BpkButton>
    </div>
  );
};

export default NavigationButton;
